// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import "./AlumniDash.css"; // Ensure correct styling

// const AlumniDash = () => {
//   const [alumni, setAlumni] = useState([]);
//   const [searchName, setSearchName] = useState("");
//   const [searchYear, setSearchYear] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const alumniPerPage = 3;

//   useEffect(() => {
//     fetchAlumni();
//   }, []);

//   const fetchAlumni = async () => {
//     try {
//       const { data } = await axios.get("http://localhost:5000/api/alumni");
//       const updatedAlumni = data.data.map((alum) => ({
//         ...alum,
//         graduationYear: alum.graduationYear || "N/A",
//         workEmail: alum.workEmail || "N/A",
//         profileImageUrl: alum.profileImageUrl
//           ? alum.profileImageUrl
//           : "https://res.cloudinary.com/dtliv3iee/image/upload/v1700000000/default-avatar.png",
//       }));

//       if (updatedAlumni.length === 0) {
//         setAlumni(sampleAlumni);
//       } else {
//         setAlumni(updatedAlumni);
//       }
//     } catch (error) {
//       console.error("Error fetching alumni", error);
//       setAlumni(sampleAlumni);
//     }
//   };

//   const handleSearch = () => {
//     let filteredAlumni = alumni;
//     if (searchName) {
//       filteredAlumni = filteredAlumni.filter((alum) =>
//         `${alum.firstName} ${alum.lastName}`
//           .toLowerCase()
//           .includes(searchName.toLowerCase())
//       );
//     }
//     if (searchYear) {
//       filteredAlumni = filteredAlumni.filter(
//         (alum) => alum.graduationYear === searchYear
//       );
//     }
//     setAlumni(filteredAlumni);
//   };

//   const sampleAlumni = [
//     {
//       _id: "1",
//       firstName: "John",
//       lastName: "Doe",
//       jobTitle: "Software Engineer",
//       company: "Google",
//       degree: "B.Tech CSE",
//       location: "New York",
//       graduationYear: "2020",
//       profileImageUrl: "https://example.com/john.jpg",
//     },
//     {
//       _id: "2",
//       firstName: "Alice",
//       lastName: "Smith",
//       jobTitle: "Product Manager",
//       company: "Amazon",
//       degree: "MBA",
//       location: "California",
//       graduationYear: "2019",
//       profileImageUrl: "https://example.com/alice.jpg",
//     },
//   ];

//   const indexOfLastAlumni = currentPage * alumniPerPage;
//   const indexOfFirstAlumni = indexOfLastAlumni - alumniPerPage;
//   const currentAlumni = alumni.slice(indexOfFirstAlumni, indexOfLastAlumni);
//   const totalPages = Math.ceil(alumni.length / alumniPerPage);
  
//   return (
//     <div className="alumni-dashboard">
//       <h2>Alumni</h2>

//       {/* Search Filters */}
//       <div className="search-filters">
//         <input
//           type="text"
//           placeholder="Search by Name"
//           value={searchName}
//           onChange={(e) => setSearchName(e.target.value)}
//         />
//         <input
//           type="text"
//           placeholder="Search by Graduation Year"
//           value={searchYear}
//           onChange={(e) => setSearchYear(e.target.value)}
//         />
//         <button onClick={() => setCurrentPage(1)}>Search</button>
//       </div>

//       {/* Alumni Cards */}
//       <div className="alumni-list">
//         {currentAlumni.map((alum) => (
//           <div key={alum._id} className="alumni-card">
//             <img src={alum.profileImageUrl} alt="profile" />
//             <h3>{`${alum.firstName} ${alum.lastName}`}</h3>
//             <p>{alum.jobTitle} at {alum.company}</p>
//             <p>{alum.degree}, Class of {alum.graduationYear}</p>
//             <p>Work Email: {alum.workEmail}</p>
//           </div>
//         ))}
//       </div>

//       {/* Pagination */}
//       <div className="pagination">
//         {Array.from({ length: totalPages }, (_, i) => (
//           <button
//             key={i + 1}
//             onClick={() => setCurrentPage(i + 1)}
//             className={currentPage === i + 1 ? "active" : ""}
//           >
//             {i + 1}
//           </button>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default AlumniDash;
// //   return (
// //     <div className="container">
// //       <div className="header">
// //         <h1>Alumni</h1>
// //       </div>
// //       <div className="filters">
// //         <input
// //           type="text"
// //           placeholder="Search by Name"
// //           value={searchName}
// //           onChange={(e) => setSearchName(e.target.value)}
// //         />
// //         <input
// //           type="text"
// //           placeholder="Search by Graduation Year"
// //           value={searchYear}
// //           onChange={(e) => setSearchYear(e.target.value)}
// //         />
// //         <button onClick={handleSearch}>Search</button>
// //       </div>
// //       <div className="cards">
// //         {currentAlumni.map((alum) => (
// //           <div key={alum._id} className="card">
// //             <img src={alum.profileImageUrl} alt="profile" />
// //             <h3>{`${alum.firstName} ${alum.lastName}`}</h3>
// //             <p>{alum.jobTitle} at {alum.company}</p>
// //             <p>{alum.degree}, Class of {alum.graduationYear}</p>
// //             <p>Location: {alum.location}</p>
// //           </div>
// //         ))}
// //       </div>
// //       <div className="pagination">
// //         {Array.from({ length: totalPages }, (_, i) => (
// //           <button
// //             key={i + 1}
// //             onClick={() => setCurrentPage(i + 1)}
// //             className={currentPage === i + 1 ? "active" : ""}
// //           >
// //             {i + 1}
// //           </button>
// //         ))}
// //       </div>
// //     </div>
// //   );
// // };

// // export default AlumniDash;

// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import "./AlumniDash.css"; // Ensure correct styling

// const AlumniDash = () => {
//   const [alumni, setAlumni] = useState([]);
//   const [filteredAlumni, setFilteredAlumni] = useState([]);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const alumniPerPage = 3;

//   useEffect(() => {
//     fetchAlumni();
//   }, []);

//   const fetchAlumni = async () => {
//     try {
//       const { data } = await axios.get("http://localhost:5000/api/alumni");
//       const updatedAlumni = data.data.map((alum) => ({
//         ...alum,
//         graduationYear: alum.graduationYear || "N/A",
//         workEmail: alum.workEmail || "N/A",
//         profileImageUrl: alum.profileImageUrl
//           ? alum.profileImageUrl
//           : "https://res.cloudinary.com/dtliv3iee/image/upload/v1700000000/default-avatar.png",
//       }));
//       setAlumni(updatedAlumni);
//       setFilteredAlumni(updatedAlumni);
//     } catch (error) {
//       console.error("Error fetching alumni", error);
//     }
//   };

//   const handleSearch = () => {
//     const query = searchQuery.toLowerCase();
//     const results = alumni.filter(
//       (alum) =>
//         `${alum.firstName} ${alum.lastName}`.toLowerCase().includes(query) ||
//         alum.workEmail.toLowerCase().includes(query) ||
//         alum.graduationYear.includes(query)
//     );
//     setFilteredAlumni(results);
//     setCurrentPage(1);
//   };

//   const indexOfLastAlumni = currentPage * alumniPerPage;
//   const indexOfFirstAlumni = indexOfLastAlumni - alumniPerPage;
//   const currentAlumni = filteredAlumni.slice(indexOfFirstAlumni, indexOfLastAlumni);
//   const totalPages = Math.ceil(filteredAlumni.length / alumniPerPage);

//   return (
//     <div className="alumni-dashboard">
//       <h2>Alumni</h2>

//       {/* Search Filters */}
//       <div className="search-filters">
//         <input
//           type="text"
//           placeholder="Search by Name, Work Email, or Year"
//           value={searchQuery}
//           onChange={(e) => setSearchQuery(e.target.value)}
//         />
//         <button onClick={handleSearch}>Search</button>
//       </div>

//       {/* Alumni Cards */}
//       <div className="alumni-list">
//         {currentAlumni.map((alum) => (
//           <div key={alum._id} className="alumni-card">
//             <p><strong>Class of {alum.graduationYear}</strong> </p>
//             <img src={alum.profileImageUrl} alt="profile" />
//             {/* <h3>{`${alum.firstName} ${alum.lastName}`}</h3> */}
//             <h3>{`${alum.firstName} ${alum.lastName}`.replace(/\b\w/g, (char) => char.toUpperCase())}</h3>

//             <p><strong>Work Email:</strong> {alum.workEmail}</p>
//           </div>
//         ))}
//       </div>

//       {/* Pagination */}
//       {totalPages > 1 && (
//         <div className="pagination">
//           {Array.from({ length: totalPages }, (_, i) => (
//             <button
//               key={i + 1}
//               onClick={() => setCurrentPage(i + 1)}
//               className={currentPage === i + 1 ? "active" : ""}
//             >
//               {i + 1}
//             </button>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// };

// export default AlumniDash;

//   // const fetchAlumni = async () => {
//   //   try {
//   //     const { data } = await axios.get("http://localhost:6000/api/alumni");
//   //     const updatedAlumni = data.data.map((alum) => ({
//   //       ...alum,
//   //       graduationYear: alum.graduationYear || "N/A",
//   //       workEmail: alum.workEmail || "N/A",
//   //       profileImageUrl: alum.profileImageUrl
//   //         ? alum.profileImageUrl
//   //         : "https://res.cloudinary.com/dtliv3iee/image/upload/v1700000000/default-avatar.png",
//   //       jobTitle: alum.jobTitle || "N/A",
//   //       currentCompany : alum.currentCompany || "N/A",
//   //       workExperience : alum.workExperience || "N/A",
//   //     }));

//   //     setAlumni(updatedAlumni);
//   //     setFilteredAlumni(updatedAlumni);
//   //   } catch (error) {
//   //     console.error("Error fetching alumni", error);
//   //   }
//   // };

//   // const fetchAlumni = async () => {
//   //   try {
//   //     const response = await axios.get("http://localhost:5080/api/alumni", {
//   //       headers: { "Content-Type": "application/json" },
//   //     });
//   //     const alumniData = response.data?.data || []; // Ensure array fallback
  
//   //     const updatedAlumni = alumniData.map((alum) => ({
//   //       ...alum,
//   //       graduationYear: alum.graduationYear || "N/A",
//   //       workEmail: alum.workEmail || "N/A",
//   //       profileImageUrl: alum.profileImageUrl
//   //         ? alum.profileImageUrl
//   //         : "https://res.cloudinary.com/dtliv3iee/image/upload/v1700000000/default-avatar.png",
//   //       jobTitle: alum.jobTitle || "N/A",
//   //       currentCompany: alum.currentCompany || "N/A",
//   //       workExperience: alum.workExperience || "N/A",
//   //     }));
  
//   //     setAlumni(updatedAlumni); // ✅ Ensure data is stored in state
//   //   } catch (error) {
//   //     console.error("❌ Error fetching alumni:", error?.response?.data || error.message);
//   //     setAlumni([]); // Fallback to empty state
//   //   }
//   // };
// -----------------------------------------------------------------------------------Commenting the last updated code which was working only for static cards----------------------------------------------
// import React, { useState /*, useEffect */ } from "react";
// // import axios from "axios";
// import "./AlumniDash.css"; // Ensure correct styling

// const AlumniDash = () => {
//   const [alumni, setAlumni] = useState([
//     { _id: "1", firstName: "Gauri", lastName: "Sharma", graduationYear: "2020", jobTitle: "Lead Associate", currentCompany: "EY", workEmail: "N/A", profileImageUrl: "../../staticalumni/Gauri.JPG" },
//     { _id: "2", firstName: "Utkarsh", lastName: "Varshney", graduationYear: "2024", jobTitle: "Acturial Trainee Analyst", currentCompany: "WTW", workEmail: "N/A", profileImageUrl: "../../staticalumni/Utkarsh.jpeg" },
//     // { _id: "6", firstName: "Aditi", lastName: "Jain", graduationYear: "2024", jobTitle: "N/A", currentCompany: "N/A", workEmail: "N/A", profileImageUrl: "" },
//     { _id: "3", firstName: "Yusha", lastName: "Jamal", graduationYear: "2022", jobTitle: "Assistant Account Executive", currentCompany: "Burson", workEmail: "N/A", profileImageUrl: "../../staticalumni/Yusha.jpeg" },
//     { _id: "4", firstName: "Dhriti", lastName: "Arora", graduationYear: "2023", jobTitle: "N/A", currentCompany: "Pursuing Masters", workEmail: "N/A", profileImageUrl: "../../staticalumni/Dhriti.jpeg" },
//     { _id: "5", firstName: "Muskan", lastName: "Gupta", graduationYear: "2021", jobTitle: "Senior Executive", currentCompany: "Deloitte", workEmail: "N/A", profileImageUrl: "../../staticalumni/Muskan_updtd.jpeg" },
//   ]);
//   const [filteredAlumni, setFilteredAlumni] = useState([
//     { _id: "1", firstName: "Gauri", lastName: "Sharma", graduationYear: "2020", jobTitle: "Lead Associate", currentCompany: "EY", workEmail: "N/A", profileImageUrl: "../../staticalumni/Gauri.JPG" },
//     { _id: "2", firstName: "Utkarsh", lastName: "Varshney", graduationYear: "2024", jobTitle: "Acturial Trainee Analyst", currentCompany: "WTW", workEmail: "N/A", profileImageUrl: "../../staticalumni/Utkarsh.jpeg" },
//     // { _id: "6", firstName: "Aditi", lastName: "Jain", graduationYear: "2024", jobTitle: "N/A", currentCompany: "N/A", workEmail: "N/A", profileImageUrl: "" },
//     { _id: "3", firstName: "Yusha", lastName: "Jamal", graduationYear: "2022", jobTitle: "Assistant Account Executive", currentCompany: "Burson", workEmail: "N/A", profileImageUrl: "../../staticalumni/Yusha.jpeg" },
//     { _id: "4", firstName: "Dhriti", lastName: "Arora", graduationYear: "2023", jobTitle: "Pursuing Masters", currentCompany: "Gokhale Institute", workEmail: "N/A", profileImageUrl: "../../staticalumni/Dhriti.jpeg" },
//     { _id: "5", firstName: "Muskan", lastName: "Gupta", graduationYear: "2021", jobTitle: "Senior Executive", currentCompany: "Deloitte", workEmail: "N/A", profileImageUrl: "../../staticalumni/Muskan_updtd.jpeg" },
//   ]);
//   const [nameQuery, setNameQuery] = useState("");
//   const [emailQuery, setEmailQuery] = useState("");
//   const [yearQuery, setYearQuery] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const alumniPerPage = 9;

//   useEffect(() => {
//     fetchAlumni();
//   }, []);

//   const fetchAlumni = async () => {
//     try {
//       const response = await axios.get("http://profile-card-service-arc.onrender.com/api/alumni", {
//         headers: { "Content-Type": "application/json" },
//       });
//       const alumniData = response.data?.data || [];
  
//       const updatedAlumni = alumniData.map((alum) => ({
//         ...alum,
//         graduationYear: alum.graduationYear || "N/A",
//         workEmail: alum.workEmail || "N/A",
//         profileImageUrl: alum.profileImageUrl
//           ? alum.profileImageUrl
//           : "https://res.cloudinary.com/dtliv3iee/image/upload/v1700000000/default-avatar.png",
//         jobTitle: alum.jobTitle || "N/A",
//         currentCompany: alum.currentCompany || "N/A",
//         workExperience: alum.workExperience || "N/A",
//       }));
  
//       setAlumni(updatedAlumni);
//       setFilteredAlumni(updatedAlumni); // ✅ Ensure data is displayed
  
//     } catch (error) {
//       console.error("❌ Error fetching alumni:", error?.response?.data || error.message);

// // Currently only the fallback for the static ones work will uncomment the usestate and the fetchusers when the backend is properly setup to connect and fetch cards
//   //     // Fallback to static data when backend fails

//   //     const sampleAlumni = [
//   //       { _id: "1", firstName: "Gauri", lastName: "Sharma", graduationYear: "2020", jobTitle: "Lead Associate", currentCompany: "EY", workEmail: "N/A", profileImageUrl: "../../staticalumni/Gauri.JPG" },
//   //       { _id: "2", firstName: "Utkarsh", lastName: "Varshney", graduationYear: "2024", jobTitle: "Acturial Trainee Analyst", currentCompany: "WTW", workEmail: "N/A", profileImageUrl: "../../staticalumni/Utkarsh.jpeg" },
//   //       // { _id: "6", firstName: "Aditi", lastName: "Jain", graduationYear: "2024", jobTitle: "N/A", currentCompany: "N/A", workEmail: "N/A", profileImageUrl: "" },
//   //       { _id: "3", firstName: "Yusha", lastName: "Jamal", graduationYear: "2022", jobTitle: "Assistant Account Executive", currentCompany: "Burson", workEmail: "N/A", profileImageUrl: "../../staticalumni/Yusha.jpeg" },
//   //       { _id: "4", firstName: "Dhriti", lastName: "Arora", graduationYear: "2023", jobTitle: "N/A", currentCompany: "Pursuing Masters in Economics from Gokhale Institute", workEmail: "N/A", profileImageUrl: "../../staticalumni/Dhriti.jpeg" },
//   //       { _id: "5", firstName: "Muskan", lastName: "Gupta", graduationYear: "2021", jobTitle: "Senior Executive", currentCompany: "Deloitte", workEmail: "N/A", profileImageUrl: "../../staticalumni/Muskan_updtd.jpeg" },
//   //     ];
//   //     setAlumni(sampleAlumni);
//   //     setFilteredAlumni(sampleAlumni); // Use static data on error
//     }
//   };
  
  
//   const handleSearch = () => {
//     const filteredResults = alumni.filter((alum) => {
//       const fullName = `${alum.firstName} ${alum.lastName}`.toLowerCase();
//       const email = alum.workEmail.toLowerCase();
//       const year = alum.graduationYear.toString();

//       return (
//         (nameQuery === "" || fullName.includes(nameQuery.toLowerCase())) &&
//         (emailQuery === "" || email.includes(emailQuery.toLowerCase())) &&
//         (yearQuery === "" || year.includes(yearQuery))
//       );
//     });

//     setFilteredAlumni(filteredResults);
//     setCurrentPage(1);
//   };

//   const indexOfLastAlumni = currentPage * alumniPerPage;
//   const indexOfFirstAlumni = indexOfLastAlumni - alumniPerPage;
//   const currentAlumni = filteredAlumni.slice(indexOfFirstAlumni, indexOfLastAlumni);
//   const totalPages = Math.ceil(filteredAlumni.length / alumniPerPage);

//   return (
//     <div className="alumni-dashboard">
      

//       {/* Search Filters */}
//       <div className="search-filters">
//         <input
//           type="text"
//           placeholder="Search by name..."
//           value={nameQuery}
//           onChange={(e) => setNameQuery(e.target.value)}
//         />
//         <input
//           type="text"
//           placeholder="Search by work email..."
//           value={emailQuery}
//           onChange={(e) => setEmailQuery(e.target.value)}
//         />
//         <input
//           type="text"
//           placeholder="Search by graduation year..."
//           value={yearQuery}
//           onChange={(e) => setYearQuery(e.target.value)}
//         />
//         <button onClick={handleSearch}>Search</button>
//       </div>

//       {/* Alumni Cards */}
//       <div className="alumni-list">
//         {currentAlumni.map((alum) => (
//           <div key={`${alum.firstName}-${alum.lastName}`} className="alumni-card">
//             <p><strong>Class of {alum.graduationYear}</strong></p>
//             <img src={alum.profileImageUrl} alt="profile" />
//             <h3>{`${alum.firstName} ${alum.lastName}`.replace(/\b\w/g, (char) => char.toUpperCase())}</h3>
//             <p><strong>{`${alum.jobTitle} , ${alum.currentCompany}`.replace(/\b\w/g, (char) => char.toUpperCase())}</strong></p>
//             <p><strong>{alum.workExperience}</strong></p>
//             <p>✉️{alum.workEmail}</p> 
//           </div>
//         ))}
//       </div>

//       {/* Pagination */}
//       {totalPages > 1 && (
//         <div className="pagination">
//           {Array.from({ length: totalPages }, (_, i) => (
//             <button
//               key={i + 1}
//               onClick={() => setCurrentPage(i + 1)}
//               className={currentPage === i + 1 ? "active" : ""}
//             >
//               {i + 1}
//             </button>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// };

// export default AlumniDash;
// -----------------------------------------------------------------------------------------------------------------------comment ends-------------------------------------------------------------------------------



import React, { useState, useEffect } from "react";
import axios from "axios";
import "./AlumniDash.css"; // Ensure correct styling

const AlumniDash = () => {
  const [alumni, setAlumni] = useState([]);
  const [filteredAlumni, setFilteredAlumni] = useState([]);
  const [nameQuery, setNameQuery] = useState("");
  const [emailQuery, setEmailQuery] = useState("");
  const [yearQuery, setYearQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const alumniPerPage = 6;

  // Static fallback data
  const sampleAlumni = [
    { _id: "1", firstName: "Gauri", lastName: "Sharma", graduationYear: "2020", jobTitle: "Lead Associate", currentCompany: "EY", workEmail: "N/A", profileImageUrl: "../../staticalumni/Gauri.JPG" },
    { _id: "2", firstName: "Utkarsh", lastName: "Varshney", graduationYear: "2024", jobTitle: "Acturial Trainee Analyst", currentCompany: "WTW", workEmail: "N/A", profileImageUrl: "../../staticalumni/Utkarsh.jpeg" },
    { _id: "3", firstName: "Yusha", lastName: "Jamal", graduationYear: "2022", jobTitle: "Assistant Account Executive", currentCompany: "Burson", workEmail: "N/A", profileImageUrl: "../../staticalumni/Yusha.jpeg" },
    { _id: "4", firstName: "Dhriti", lastName: "Arora", graduationYear: "2023", jobTitle: "Pursuing Masters", currentCompany: "Gokhale Institute", workEmail: "N/A", profileImageUrl: "../../staticalumni/Dhriti.jpeg" },
    { _id: "5", firstName: "Muskan", lastName: "Gupta", graduationYear: "2021", jobTitle: "Senior Executive", currentCompany: "Deloitte", workEmail: "N/A", profileImageUrl: "../../staticalumni/Muskan_updtd.jpeg" },
  ];

  useEffect(() => {
    fetchAlumni();
  }, []);

  const fetchAlumni = async () => {
    try {
      const response = await axios.get("https://profile-card-service.onrender.com/api/alumni", {
        headers: { "Content-Type": "application/json" },
      });
      const alumniData = response.data?.data || [];

      // Process API data
      const updatedAlumni = alumniData.map((alum) => ({
        ...alum,
        graduationYear: alum.graduationYear || "N/A",
        workEmail: alum.workEmail || "N/A",
        profileImageUrl: alum.profileImageUrl
          ? alum.profileImageUrl
          : "https://res.cloudinary.com/dtliv3iee/image/upload/v1700000000/default-avatar.png",
        jobTitle: alum.jobTitle || "N/A",
        currentCompany: alum.currentCompany || "N/A",
        workExperience: alum.workExperience || "N/A",
      }));

      // If no valid data from API, use static data
      if (updatedAlumni.length === 0) {
        setAlumni(sampleAlumni);
        setFilteredAlumni(sampleAlumni);
      } else {
        setAlumni(updatedAlumni);
        setFilteredAlumni(updatedAlumni);
      }
    } catch (error) {
      console.error("❌ Error fetching alumni:", error?.response?.data || error.message);
      // Fallback to static data on error
      setAlumni(sampleAlumni);
      setFilteredAlumni(sampleAlumni);
    }
  };

  const handleSearch = () => {
    const filteredResults = alumni.filter((alum) => {
      const fullName = `${alum.firstName} ${alum.lastName}`.toLowerCase();
      const email = alum.workEmail.toLowerCase();
      const year = alum.graduationYear.toString();

      return (
        (nameQuery === "" || fullName.includes(nameQuery.toLowerCase())) &&
        (emailQuery === "" || email.includes(emailQuery.toLowerCase())) &&
        (yearQuery === "" || year.includes(yearQuery))
      );
    });

    setFilteredAlumni(filteredResults);
    setCurrentPage(1);
  };

  const indexOfLastAlumni = currentPage * alumniPerPage;
  const indexOfFirstAlumni = indexOfLastAlumni - alumniPerPage;
  const currentAlumni = filteredAlumni.slice(indexOfFirstAlumni, indexOfLastAlumni);
  const totalPages = Math.ceil(filteredAlumni.length / alumniPerPage);

  return (
    <div className="alumni-dashboard">
      {/* Search Filters */}
      <div className="search-filters">
        <input
          type="text"
          placeholder="Search by name..."
          value={nameQuery}
          onChange={(e) => setNameQuery(e.target.value)}
        />
        <input
          type="text"
          placeholder="Search by work email..."
          value={emailQuery}
          onChange={(e) => setEmailQuery(e.target.value)}
        />
        <input
          type="text"
          placeholder="Search by graduation year..."
          value={yearQuery}
          onChange={(e) => setYearQuery(e.target.value)}
        />
        <button onClick={handleSearch}>Search</button>
      </div>

      {/* Alumni Cards */}
      <div className="alumni-list">
        {currentAlumni.map((alum) => (
          <div key={`${alum.firstName}-${alum.lastName}`} className="alumni-card">
            <p><strong>Class of {alum.graduationYear}</strong></p>
            <img src={alum.profileImageUrl} alt="profile" />
            <h3>{`${alum.firstName} ${alum.lastName}`.replace(/\b\w/g, (char) => char.toUpperCase())}</h3>
            <p><strong>{`${alum.jobTitle}, ${alum.currentCompany}`.replace(/\b\w/g, (char) => char.toUpperCase())}</strong></p>
            <p><strong>{alum.workExperience}</strong></p>
            <p>✉️ {alum.workEmail}</p>
          </div>
        ))}
      </div>

      {/* Pagination */}
      {totalPages > 1 && (
        <div className="pagination">
          {Array.from({ length: totalPages }, (_, i) => (
            <button
              key={i + 1}
              onClick={() => setCurrentPage(i + 1)}
              className={currentPage === i + 1 ? "active" : ""}
            >
              {i + 1}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default AlumniDash;

